<template>
  <v-simple-table class="elevation-0 mb-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th>UNIDADE</th>
          <th>SIGLA</th>
          <th class="text-center">{{ `${itemA.letra}. ${itemA.descricao}`.toUpperCase() }}</th>
          <th class="text-center">{{ `${itemB.letra}. ${itemB.descricao}`.toUpperCase() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="resposta in respostas"
          :key="resposta.id"
        >
          <td>
            <span class="grey--text text--darken-2">{{ resposta.nome }}</span>
          </td>
          <td>
            <span class="grey--text text--darken-2">{{ resposta.sigla }}</span>
          </td>
          <td class="text-center">
            <span class="grey--text text--darken-2">{{ resposta.itemA }}</span>
          </td>
          <td class="text-center">
            <span class="grey--text text--darken-2">{{ resposta.itemB }}</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ExpansaoResultadoGeralPreferencia',

  props: {
    itemA: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    itemB: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    respostas: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
